module.exports = __webpack_public_path__ + "entry-150bfe9b/vanessa-strauch.256x256-2af15035cf328d5f012599fae56750d5.webp";